import { ref } from 'vue'
import { apiRoutes } from '../infraestructure/apiRoutes'
import { get } from '../infraestructure/repository/generic.repository'

const useCatalog = () => {

  const searchText = ref('')
  const catalogs = ref([])
  const tableLoading = ref(false)

  const getCatalogs = async () => {
    tableLoading.value = true

    const path = `${apiRoutes.catalog}?search=${searchText.value}`
    const response = await get(path)
    const { items } = response.data
    catalogs.value = items
    tableLoading.value = false
  }
  getCatalogs()

  return {
    searchText,
    catalogs,
    tableLoading,

    getCatalogs,
  }

}

export default useCatalog
